export default __webpack_public_path__ + "static/media/KM.c396d884.svg";